import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Modal } from "../../components/Modal";
import { Form, Input } from "antd";
import { useAuth } from "../../contexts/auth";
import { sendMessage } from "../../services/support/api";
import { createNotification } from "../../components";

export default function SupportModal({ open, onCancel, onSubmit }) {
  const intl = useIntl();

  const { user, partner } = useAuth();

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    setLoading(true);

    const payload = {
      name: user.name,
      email: user.email,
      phone: partner.tel,
      message: message,
    };

    await sendMessage(payload)
      .then(() => {
        createNotification("success", intl.formatMessage({ id: "modal.support.notification" }));
        setLoading(false);
        onSubmit();
      })
      .finally(() => {
        setMessage("");
      });
  }

  return (
    <Modal.Root visible={open}>
      <Modal.Header onCancelAction={onCancel} title={intl.formatMessage({ id: "page.support.title" })} />
      <Modal.Content align="start">
        <Form layout="vertical">
          <div className="grid grid-cols-2 gap-2">
            <Form.Item label={intl.formatMessage({ id: "modal.support.name" })} required>
              <Input required size="large" disabled value={user.name} />
            </Form.Item>
            <Form.Item label={intl.formatMessage({ id: "modal.support.phone" })} required>
              <Input required size="large" disabled value={partner.tel} />
            </Form.Item>
          </div>
          <Form.Item label={intl.formatMessage({ id: "modal.support.email" })} required>
            <Input required size="large" disabled value={user.email} />
          </Form.Item>

          <Form.Item
            style={{ marginBottom: 35 }}
            hasFeedback
            label={intl.formatMessage({ id: "modal.support.message" })}
            required
            rules={[{ required: true, message: "Please type your message!" }]}
          >
            <Input.TextArea
              rows={4}
              type="text"
              value={message}
              onInput={(e) => setMessage(e.target.value)}
            />
          </Form.Item>
        </Form>
      </Modal.Content>
      <Modal.Actions
        loading={loading}
        onSubmitAction={handleSubmit}
        submitText={intl.formatMessage({ id: "send" })}
        onCancelAction={onCancel}
      />
    </Modal.Root>
  );
}
